<template>
  <v-footer class="py-4" dark height="auto">
    <v-container>
      <v-layout wrap>
        <v-flex xs12 md3>
          <v-list class="transparent">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="elevation-4" dark>
                  mdi-email-outline
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-subtitle>
                vtsv@wanadoo.fr
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="elevation-4" dark>
                  mdi-phone
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-subtitle>
                06 60 52 41 57 <br />
                04 79 20 41 57
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="elevation-4" dark>
                  mdi-map-marker
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-subtitle>
                245 rue du Roc rouge<br />
                Zone Industrielle des terres blanches <br />
                73500 Modane
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs12 md3>
          <v-list class="transparent"> </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        href: "#!",
        icon: "mdi-twitter"
      },
      {
        href: "#!",
        icon: "mdi-instagram"
      },
      {
        href: "#!",
        icon: "mdi-facebook"
      },
      {
        href: "#!",
        icon: "mdi-google-plus"
      },
      {
        href: "#!",
        icon: "mdi-reddit"
      },
      {
        href: "#!",
        icon: "mdi-discord"
      },
      {
        href: "#!",
        icon: "mdi-pinterest"
      }
    ]
  })
};
</script>
